import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { TranslateService } from '@ngx-translate/core';
import { SharedDataService } from '@app/services/net-remit/shared-data.service';

import { merge } from 'rxjs';
import { filter, map, mergeMap, takeWhile } from 'rxjs/operators';

import { environment } from '@env/environment';
import { Logger } from '@app/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class AppComponent implements OnInit, OnDestroy {

  alive: boolean = true;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private sharedDataService: SharedDataService,
    private translateService: TranslateService) {
      const lang = localStorage.getItem("language");
      translateService.setDefaultLang(environment.defaultLanguage);
      translateService.use(!lang ? environment.defaultLanguage : lang);
  }

  ngOnInit() {
    // Setup logger
    if (environment.production) {
    Logger.enableProductionMode();
    }

    const onNavigationEnd = this.router.events.pipe(filter(event => event instanceof NavigationEnd));

    // Change page title on navigation or language change, based on route data
    merge(this.translateService.onLangChange, onNavigationEnd).pipe(takeWhile(() => this.alive))
    .pipe(
      map(() => {
        let route = this.activatedRoute;
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter(route => route.outlet === 'primary'),
      mergeMap(route => route.data)
    )
    .subscribe(event => {
      const title = event['title'];
      this.sharedDataService.updateLanguage();
      if (title) {
      this.titleService.setTitle(this.translateService.instant(title));
      }
    });
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.alive = false;
  }
}
